import {canvasImageSelection,newTaskImageModel} from './sunburst';

/** Auto is application intent, never a provider aspect ratio. */
export function toggleImageRatio(current: readonly string[], ratio: string, allowed: readonly string[]): string[] {
  if (ratio === 'auto') return ['auto'];
  if (!allowed.includes(ratio)) return [...current];
  const explicit = current.filter(value => allowed.includes(value));
  if (explicit.length === 1 && explicit[0] === ratio) return explicit;
  return allowed.filter(value => value === ratio ? !explicit.includes(value) : explicit.includes(value));
}

export function imageRatiosForTask(state: {activeProjectId:number|null;selectedAspectRatios:string[];aspectRatiosByProject?:Record<number,string[]>}, projectId:number|null): string[] {
  return [...(state.activeProjectId === projectId ? state.selectedAspectRatios : projectId == null ? ['auto'] : state.aspectRatiosByProject?.[projectId] ?? ['auto'])];
}

export function imageModelForTask(state:{imageModel:string;imageModelUserSelected?:boolean;generationMedium?:string;imageTier:string|null;imageResolution:string;imageModelByProject:Record<number,string>;imageTierByProject:Record<number,string|null>;imageResolutionByProject:Record<number,string>}, projectId:number|null) {
  const model=projectId == null ? newTaskImageModel(state.imageModel,state.imageModelUserSelected,state.generationMedium) : state.imageModelByProject[projectId] ?? state.imageModel;
  const tier=projectId == null ? state.imageTier : state.imageTierByProject[projectId] ?? state.imageTier;
  const resolution=projectId == null ? state.imageResolution : state.imageResolutionByProject[projectId] ?? (model === 'gpt-image-2' ? undefined : state.imageResolution);
  return canvasImageSelection(model,tier,resolution);
}
